import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Australian Tax File Number validator following Single Responsibility Principle
 */
export class AusValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Australian Tax File Number',
      pattern: /^\d{8,9}$/,
      minLength: 8,
      maxLength: 9
    });
  }

  validateFormat(id) {
    // Check length
    if (id.length < this.config.minLength || id.length > this.config.maxLength) {
      return ValidationResult.invalid('TFN must be 8 or 9 digits');
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'TFN must contain only digits'
    );
  }

  validateChecksum(id) {
    const weights = [1, 4, 3, 7, 5, 8, 6, 9, 10];
    let sum = 0;

    for (let i = 0; i < Math.min(id.length, 8); i++) {
      sum += parseInt(id[i]) * weights[i];
    }

    const remainder = sum % 11;
    if (remainder === 0 || remainder === 1) {
      return ValidationResult.valid('Valid TFN');
    }

    return ValidationResult.invalid('Invalid TFN checksum');
  }
}